import React from 'react';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import Tooltip from '@mui/material/Tooltip';
import { MAIN_THEME } from '@styles';
import IconWrapper from '@components/common/IconWrapper';

interface IEnhanceIconButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  title: string;
  iconUrl: string;
  iconOnly?: boolean;
  hasBackground?: boolean;
  customTooltips?: boolean;
  customTooltipActive?: string;
  customTooltipDisabled?: string;
}

const useStyles = makeStyles()(() => ({
  button: {
    margin: '0.5em',
    border: 'none',
    background: 'unset',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.4,
    },
    fontFamily: `${MAIN_THEME} !important`,
  },
  text: {
    margin: '1em auto 0',
    display: 'block',
    color: MAIN_THEME.color.black,
    font: 'normal',
    fontSize: MAIN_THEME.fontSize.xs,
    lineHeight: '12px',
    fontFamily: MAIN_THEME.font.regular,
    textAlign: 'center',
  },
}));

const EnhancedIconButton: React.FC<IEnhanceIconButtonProps> = ({
  className,
  title,
  iconUrl,
  iconOnly,
  hasBackground,
  customTooltips = false,
  customTooltipActive = '',
  customTooltipDisabled = '',
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <button
      className={clsx(classes.button, className)}
      type="button"
      {...props}
    >
      {iconOnly ? (
        <Tooltip
          title={
            customTooltips
              ? props.disabled
                ? customTooltipDisabled
                : customTooltipActive
              : title
          }
        >
          <span>
            <IconWrapper
              title={title}
              hasBackground={hasBackground}
              iconUrl={iconUrl}
            />
          </span>
        </Tooltip>
      ) : (
        iconUrl !== '' && (
          <IconWrapper
            title={title}
            hasBackground={hasBackground}
            iconUrl={iconUrl}
          />
        )
      )}
      {!iconOnly && <span className={classes.text}>{title}</span>}
    </button>
  );
};

export default EnhancedIconButton;
